export default __webpack_public_path__ + "static/media/a' cuideachadh.8b602607.mp3";